import { Box, ButtonBase, styled } from "@mui/material";
import { useAppDispatch } from "../../store/hooks";
import { H6, Small } from "../../components/Typography";
import { useState, useEffect, useRef, Fragment } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import PopoverLayout from "./PopoverLayout";
import { load, remove } from "../../constants/storage";
import { getUserInfo } from "../../redux/actions";

const StyledSmall = styled(Small)(({ theme }) => ({
  display: "block",
  padding: "7px 1rem",
  cursor: "pointer",
  fontSize: "14px", // add fontSize property
  fontFamily: "'Poppins', sans-serif",
  fontWeight: "500",
  "&:hover": {
    background:
      " linear-gradient(150.93deg, #FFF3DB 24.82%, rgba(246, 255, 228, 0) 83.94%)",
  },
}));
type ProfileBarProps = {
  userImages?: string;
};

function ProfilePopover({ userImages }: ProfileBarProps) {
  const anchorRef = useRef(null);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);

  const [kycStatus, setuserKYCStatus] = useState("");
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [userImage, setUserImage] = useState("");
  const handleMenuItem = (path: string) => {
    navigate(path);
    setOpen(false);
  };

  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    const countryCode: any = "91";
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    let token = load("token");
    setUserName(finalUser.firstname + " " + finalUser.lastname);
    setEmail(finalUser.email);
    const req = {
      id: finalUser?.id,
      mobile: finalUser?.mobile,
      partner: finalUser?.refcode,
      source: "web",
    };

    dispatch(getUserInfo(req, `bearer ${token}`))
      .then(async (response: any) => {
        let acruUser = response?.data[0];
        setUserImage(response?.data[0]?.user_photo);
        setuserKYCStatus(acruUser.user_status);
      })
      .catch((error: any) => {
        console.log(`Error: ${error} | ${error?.description}`);
      });
  };

  const handleMenuItemClick = (path: string) => {
    if (kycStatus === "ACTIVE") {
      navigate(path);
      setOpen(false);
    } else {
      toast.error("Please complete your KYC.");
      setOpen(false);
    }
  };

  const handleTransaction = (path: string) => {
    navigate(path, {
      state: {
        type: "gold",
      },
    });
  };

  return (
    <Fragment>
      <ButtonBase disableRipple ref={anchorRef} onClick={() => setOpen(true)}>
        <Box
          component="img"
          src={
            userImage
              ? userImage
              : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/profilepic.svg"
          }
          sx={{
            width: {
              md: 35,
              xs: 25,
            },
            height: {
              md: 35,
              xs: 25,
            },
            borderRadius: "50%",
            marginLeft: {
              md: 0.4,
              xs: -1,
            },
            marginRight: 0.4,
          }}
        />
        <H6
          color="#000"
          sx={{
            fontFamily: "'Poppins', sans-serif",
            display: {
              xs: "none",
              md: "flex",
            },
          }}
        >
          {userName ? userName : ""}
        </H6>
      </ButtonBase>
      <PopoverLayout
        hiddenViewButton
        maxWidth={230}
        minWidth={200}
        popoverOpen={open}
        anchorRef={anchorRef}
        popoverClose={() => setOpen(false)}
      >
        <Box pt={0}>
          <StyledSmall onClick={() => handleMenuItem("/myProfile")}>
            My Profile
          </StyledSmall>
          <StyledSmall onClick={() => handleMenuItem("/bankDetails")}>
            Bank Details
          </StyledSmall>
          <StyledSmall onClick={() => handleTransaction("/transaction")}>
            Transaction History
          </StyledSmall>
          <StyledSmall onClick={() => handleMenuItemClick("/nominee")}>
            Manage Nominees
          </StyledSmall>
          <StyledSmall onClick={() => handleMenuItemClick("/support")}>
            Support
          </StyledSmall>
          <StyledSmall
            onClick={() => {
              remove("userData");
              remove("token");
              remove("tabState");
              remove("PANVerify");
              toast.success("You Logout Successfully");
              navigate("/login");
            }}
          >
            Logout
          </StyledSmall>
        </Box>
      </PopoverLayout>
    </Fragment>
  );
}

export default ProfilePopover;
